import { GasStationBrand } from "@1games-ru/region-shared/dist/enums/estate/gas-station";
import {
  imgGasStationGazprom,
  imgGasStationLukoil,
  imgGasStationRosseti,
} from "@/shared/assets/img";

export const headerImg: Record<GasStationBrand, string> = {
  [GasStationBrand.Gaspro]: imgGasStationGazprom,
  [GasStationBrand.Luoil]: imgGasStationLukoil,
  [GasStationBrand.Russeti]: imgGasStationRosseti,
};
